import { render, staticRenderFns } from "./tableList.vue?vue&type=template&id=f52d5c58&scoped=true"
import script from "./tableList.vue?vue&type=script&lang=js"
export * from "./tableList.vue?vue&type=script&lang=js"
import style0 from "./tableList.vue?vue&type=style&index=0&id=f52d5c58&prod&lang=scss"
import style1 from "./tableList.vue?vue&type=style&index=1&id=f52d5c58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52d5c58",
  null
  
)

export default component.exports